export enum YollandaFeedback {
  like = 1,
  dislike = 2,
}

export type YollandaInteractionId = string;

export interface AnalyticsInsightsRequestParams {
  readonly Definition: {
    ReportPage: { Title: string; Description: string };
    Section: { Title: string | null; Description: string | null };
    ReportItem: unknown;
  };
  readonly Data: unknown;
  readonly Filters: unknown[];
  readonly URL: string;
  readonly InteractionIdFE: string;
}
